



























import {Component, Prop, PropSync, Vue, Emit} from 'vue-property-decorator'
import { DxTagBox } from 'devextreme-vue/ui/tag-box';
import {
  DxValidator,
  DxRequiredRule,
  DxEmailRule,
  DxStringLengthRule
} from 'devextreme-vue/validator';

@Component({
  name: 'DTagbox',
  components: {
    DxTagBox,
    DxValidator,
    DxRequiredRule,
    DxEmailRule,
    DxStringLengthRule
  }
})
export default class extends Vue {

  @Prop() public dataSource!: any;
  @PropSync('inputData') synceInputData!: any;
  @Prop({ default: '' }) public title!: string;
  @Prop({ default: false }) public isRequired!: boolean;
  @Prop({ required: true }) public valueExpr!: string;
  @Prop({ required: true }) public displayExpr!: string;
  @Prop() public placeholder!: string;
  @Prop({ default: false }) public multiline!: boolean;
  @Prop({ default: false }) public disabled!: boolean;
  @Prop({ default: false }) public readOnly!: boolean;
  @Prop({ default: true }) public selectAll!: boolean;

  created() {

  }

  @Emit("valueChanged")
  onValueChanged(e:any) {
    return e;
  }

  @Emit("closed")
  onClosed(e:any) {
    return e;
  }
}
